module.exports = "<div class='navigation-bar-desktop-spacer'></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navigation-bar-desktop-spacer/navigation-bar-desktop-spacer.component.html
// module id = ./src/app/components/navigation-bar-desktop-spacer/navigation-bar-desktop-spacer.component.html
// module chunks = main